/**
 * Agent status values
 */
export enum AgentStatusEnum {
	/**
	 * Agent account is active and in good standing
	 */
	ACTIVE = 'active',
	/**
	 * Agent account is on hold due to other reasons
	 */
	ON_HOLD = 'on_hold',
	/**
	 * Agent account is closed
	 */
	CLOSED = 'closed',
}
